import type { CompanyFollower } from "@/modules/companies/api/types"

import { useQuery } from "@tanstack/react-query"
import { useParams } from "next/navigation"

import {
  DEFAULT_QUERY_CACHE_TIME as QUERY_CACHE_TIME,
  DEFAULT_QUERY_STALE_TIME as QUERY_STALE_TIME,
} from "@/modules/api/constants"
import { getCompanyFollower } from "@/modules/companies/api/endpoints/companyFollower"
import { COMPANY_FOLLOWER_QUERY_KEY } from "@/modules/companies/api/endpoints/constants"
import { useCompanyFetch } from "@/modules/companies/hooks/useCompanyFetch"

type CompanyFollowerFetch = {
  dataCompanyFollower?: CompanyFollower
  isErrorCompanyFollower: boolean
  isLoadingCompanyFollower: boolean
  isSuccessCompanyFollower: boolean
}
export const useCompanyFollowerFetch = (): CompanyFollowerFetch => {
  const { companySlug } = useParams<{ companySlug: string }>()
  const { dataCompany } = useCompanyFetch()

  const {
    data: dataCompanyFollower,
    isError: isErrorCompanyFollower,
    isPending: isLoadingCompanyFollower,
    isSuccess: isSuccessCompanyFollower,
  } = useQuery({
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getCompanyFollower({ permalink: companySlug }),
    queryKey: [COMPANY_FOLLOWER_QUERY_KEY, dataCompany?.id, companySlug],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCompanyFollower,
    isErrorCompanyFollower,
    isLoadingCompanyFollower,
    isSuccessCompanyFollower,
  }
}
